export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.15.0',
};
//# sourceMappingURL=buildEnv.js.map